import {colors} from 'styles/colors';

/**
 * 지정 상태 스타일
 * 지정 상태에 따른 텍스트와 배경색을 정의한 객체입니다.
 */
export const specifyStatus: {[key: string]: any} = {
  REQUESTED: {
    text: 'waitingApproval',
    backgroundColor: colors.darkLimeGreen,
  },
  ALLOWED: {
    text: 'designationComplete',
    backgroundColor: colors.primary,
  },
  DISALLOWED: {
    text: 'designationCanceled',
    backgroundColor: colors.gray,
  },
};

/**
 * 처리 스타일
 * 처리 상태에 따른 텍스트와 배경색을 정의한 객체입니다.
 */
export const processingStyle: {[key: string]: any} = {
  processing: {
    text: 'processing',
    backgroundColor: '#E61E16',
  },
  completed: {
    text: 'completed',
    backgroundColor: colors.darkGray,
  },
};

/**
 * 등록 상태 스타일
 * 등록 상태에 따른 텍스트와 색상을 정의한 객체입니다.
 */
export const registerStateStyle: {[key: string]: any} = {
  APP_USE_UNAPPROVED: {
    text: 'requestAppRegister',
    color: colors.primary,
  },
  PROFILE_SETTING_INITIALIZED: {
    text: 'prevAppAgree',
    color: colors.black,
  },
  APP_USE_APPROVED: {
    text: 'completeAppRegister',
    color: colors.black,
  },
  REMOVED: {
    text: 'withdrawal',
    color: colors.gray,
  },
  waitingForApproval: {
    text: 'waitingForApproval',
    color: colors.black,
  },
};

/**
 * 안전 출발 상태 스타일
 * 안전 출발 상태에 따른 텍스트와 색상을 정의한 객체입니다.
 */
export const departureSafeStatusStyle: {[key: string]: any} = {
  ACCIDENT_MEASURE_COMPLETE: {
    text: 'accidentResolved',
    color: colors.black,
  },
  USER_OUT: {
    text: 'safeLeave',
    color: colors.gray,
  },
  ACCIDENT_OUT: {
    text: 'accidentOccurred',
    color: colors.primary,
  },
  SYSTEM_OUT: {
    text: 'safeLeave',
    color: colors.gray,
  },
};

/**
 * 현장 처리 상태
 * 현장 처리 상태에 따른 텍스트와 색상을 정의한 객체입니다.
 */
export const siteProcessingStatus = {
  NOT_STARTED: {
    text: 'preparing',
    color: colors.lighterGray,
  },
  IN_OPERATION: {
    text: 'inOperation',
    color: colors.primary2,
  },
  STOPPED: {
    text: 'stop',
    color: colors.gray,
  },
  COMPLETED: {
    text: 'complete',
    color: colors.gypsyRed,
  },
};

/**
 * 권한 상태
 * 권한 상태에 따른 텍스트와 색상을 정의한 객체입니다.
 */
export const permissionStateStatus: {[key: string]: any} = {
  REQUESTED: {
    text: 'waitingForApproval',
    color: colors.primary,
  },
  ALLOWED: {
    text: 'completeApprove2',
    color: colors.black,
  },
  DISALLOWED: {
    text: 'deniedApprove',
    color: colors.gray,
  },
  RESIGNED: {
    text: 'resignationComplete',
    color: colors.vividRed,
  },
};

/**
 * 작업 날짜 상태
 * 작업 날짜 상태에 따른 텍스트와 색상을 정의한 객체입니다.
 */
export const workDateStateStatus: {[key: string]: any} = {
  waitingForWork: {
    text: 'waitingForWork',
    color: colors.darkLimeGreen,
  },
  duringWorkPeriod: {
    text: 'duringWorkPeriod',
    color: colors.primary,
  },
  workCompleted: {
    text: 'workCompleted',
    color: colors.gray,
  },
};

/**
 * 승인 상태
 * 승인 상태에 따른 텍스트와 색상을 정의한 객체입니다.
 */
export const approvalStateStatus: {[key: string]: any} = {
  approval: {
    text: 'approval',
    color: colors.black,
  },
  unauthorized: {
    text: 'unauthorized',
    color: colors.primary,
  },
};

/**
 * 승인 사항 상태
 * 승인 사항 상태에 따른 텍스트와 색상을 정의한 객체입니다.
 */
export const approvalMattersStatus: {[key: string]: any} = {
  unauthorized: {
    text: 'unauthorized',
    color: colors.primary,
  },
  approved: {
    text: 'approved',
    color: colors.black,
  },
};

/**
 * 허용 상태
 * 허용 상태에 따른 텍스트와 색상을 정의한 객체입니다.
 */
export const allowStateStatus: {[key: string]: any} = {
  REQUESTED: {
    text: 'registrationPending',
    color: colors.primary,
  },
  ALLOWED: {
    text: 'registrationCompleted',
    color: colors.black,
  },
  DISALLOWED: {
    text: 'registrationCancelled',
    color: colors.gray,
  },
};

/**
 * 교육 유형 상태
 * 교육 유형 상태에 따른 텍스트와 색상을 정의한 객체입니다.
 */
export const educationTypeStatus: {[key: string]: any} = {
  DEFAULT: {
    text: 'educationTypeStatusBundle',
    color: colors.primary2,
  },
  ETC: {
    text: 'educationTypeStatusEtc',
    color: colors.darkGray,
  },
  SPECIAL_EDUCATION: {
    text: 'specialTraining',
    color: colors.primary,
  },
  REGULAR_EDUCATION: {
    text: 'regularTraining',
    color: colors.darkLimeGreen,
  },
  ADMINISTRATOR_EDUCATION: {
    text: 'supervisorTraining',
    color: colors.black,
  },
};
